<template>
  <div class="b-qr-vehicle-aside">
    <div class="b-qr-vehicle-aside__header">
      <div class="b-qr-vehicle-aside__title">
        <span>{{ dictionary.vehicleResumeLabel }}</span>
      </div>
      <div class="b-qr-vehicle-aside__number">
        <span>#{{ panelNumber + 1 }}</span>
      </div>
    </div>
    <div class="b-qr-vehicle-aside__main">
      <div
        class="d-flex align-items-center mb-24"
        style="justify-content: space-between">
        <div class="b-qr-vehicle-aside__logo">
          <LazyImage v-if="image" :image="image" />
        </div>
        <div>
          <a
            v-if="editable"
            class="btn btn-link btn-icon-start btn-edit"
            @click="editVehicle">
            <i class="icon-edit"></i>
            <small class="extrabold">
              {{ dictionary.editOptionsButtonText }}
            </small>
          </a>
        </div>
      </div>
      <div class="row">
        <span class="extrabold mb-8">{{ brand }}</span>
        <span class="semibold mb-24">{{ vehicle.Model }}</span>
      </div>
      <div class="row">
        <div class="col-6 semibold mb-16">
          {{ dictionary.vehicleResumeFuelTypeText }}
        </div>
        <div class="col-6 extrabold mb-16">{{ fuelType }}</div>
      </div>

      <div class="form-separator mb-16"></div>

      <div class="row">
        <div class="col-6 semibold mb-16">
          {{ dictionary.vehicleResumeYearsText }}
        </div>
        <div class="col-6 extrabold mb-16">{{ leaseDuration }}</div>
      </div>

      <div class="form-separator mb-16"></div>

      <div class="row">
        <div class="col-6 semibold mb-16">
          {{ dictionary.vehicleResumeMilesPerYearText }}
        </div>
        <div class="col-6 extrabold mb-16">{{ milesPerYear }}</div>
      </div>

      <div class="form-separator mb-16"></div>

      <div class="row">
        <div class="col-6 semibold mb-16">
          {{ dictionary.vehicleResumeQuantityText }}
        </div>
        <div class="col-6 extrabold mb-16">{{ vehicle.VehicleQuantity }}</div>
      </div>

      <div
        v-if="enableBuyOut || enablePaymentInAdvance"
        class="form-separator mb-16"></div>

      <div v-if="enableBuyOut" class="row">
        <div class="col-6 semibold mb-16">
          {{ dictionary.vehicleResumeRightToBuyText }}
        </div>
        <div class="col-6 extrabold mb-16">
          <div>
            <span>{{ rightToBuy }}&nbsp;&nbsp;</span>
            <span
              v-if="vehicle.RightToBuy"
              style="font-size: 1em; color: #4a90e2">
              <strong>✔&#xFE0E;</strong>
            </span>
            <span v-else style="font-size: 1em; color: #c71818">✖&#xFE0E;</span>
          </div>
        </div>
        <div v-if="enablePaymentInAdvance" class="form-separator mb-16"></div>
      </div>

      <div v-if="enablePaymentInAdvance" class="row">
        <div class="col-6 semibold">
          {{ dictionary.paymentInAdvanceLabel }}
        </div>
        <div class="col-6 extrabold">
          <div>
            <span>{{ hasPrepayment }}&nbsp;&nbsp;</span>
            <span
              v-if="vehicle.PaymentInAdvance"
              style="font-size: 1em; color: #4a90e2">
              <strong>✔&#xFE0E;</strong>
            </span>
            <span v-else style="font-size: 1em; color: #c71818">✖&#xFE0E;</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as lib from './../../../lib/lib'
import LazyImage from '../../components/common/LazyImage.vue'

export default {
  components: {
    LazyImage,
  },
  props: {
    editable: {
      required: true,
      type: Boolean,
      default: true,
    },
    vehicle: {
      required: true,
      type: Object,
    },
    panelNumber: {
      required: true,
      type: Number,
    },
    enableBuyOut: {
      required: false,
      type: Boolean,
    },
    enablePaymentInAdvance: {
      required: false,
      type: Boolean,
    },
  },
  emits: ['get-step'],
  data() {
    return {
      vehicleQuantity: null,

      brands: [],
      fuelTypes: [],
      leaseDurationOptions: [],
      milesPerYears: [],
    }
  },
  computed: {
    brand() {
      const obj = this.brands.find((item) => item.value === this.vehicle.Brand)
      return obj ? obj.text : ''
    },
    fuelType() {
      const obj = this.fuelTypes.find(
        (item) => item.value === this.vehicle.FuelType
      )
      return obj ? obj.text : ''
    },
    leaseDuration() {
      const obj = this.leaseDurationOptions.find(
        (item) => item.value === this.vehicle.LeaseDuration
      )
      return obj ? obj.text : ''
    },

    milesPerYear() {
      const obj = this.milesPerYears.find(
        (item) => item.value === this.vehicle.MilesPerYear
      )
      return obj ? obj.text : ''
    },

    rightToBuy() {
      return this.vehicle.RightToBuy
        ? this.dictionary.vehicleResumeYesText
        : this.dictionary.vehicleResumeNoText
    },
    hasPrepayment() {
      return this.vehicle.PaymentInAdvance
        ? this.dictionary.vehicleResumeYesText
        : this.dictionary.vehicleResumeNoText
    },

    image() {
      const obj = this.brands.find((item) => item.value === this.vehicle.Brand)

      if (!obj) {
        return false
      }

      if (!obj.icon.url.length) {
        return false
      }

      return {
        url: obj.icon.url,
        alt: obj.icon.alt,
      }
    },
  },
  mounted() {
    const { brands, fuelTypes, leaseDurationOptions, milesPerYear } =
      lib.getData('quotationData')
    this.brands = brands
    this.fuelTypes = fuelTypes
    this.leaseDurationOptions = leaseDurationOptions
    this.milesPerYears = milesPerYear
  },
  methods: {
    editVehicle() {
      this.$emit('get-step', 1)
    },
  },
}
</script>
